export { default } from "./CompactButton";
